import type { JSX } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

const WebhooksLoadingTable = (): JSX.Element => {
  return (
    <div className="mt-4 overflow-x-auto">
      <table className="w-full min-w-[720px] border-collapse text-left text-sm font-body">
        <thead>
          <tr className="border-b border-border-subtle">
            <th className="py-2 pr-3 font-medium text-text-muted">Nombre</th>
            <th className="py-2 pr-3 font-medium text-text-muted">URL</th>
            <th className="py-2 pr-3 font-medium text-text-muted">Plataforma</th>
            <th className="py-2 pr-3 font-medium text-text-muted">Proyecto</th>
            <th className="py-2 pr-3 font-medium text-text-muted">Estado</th>
            <th className="py-2 pr-3 font-medium text-text-muted">Creado</th>
            <th className="py-2 text-right font-medium text-text-muted">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3].map((row) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`sk-${row}`} className="border-b border-border-subtle">
              <td className="py-2 pr-3">
                <Skeleton className="h-4 w-28" />
              </td>
              <td className="py-2 pr-3">
                <Skeleton className="h-4 w-48" />
              </td>
              <td className="py-2 pr-3">
                <Skeleton className="h-6 w-16 rounded-full" />
              </td>
              <td className="py-2 pr-3">
                <Skeleton className="h-4 w-24" />
              </td>
              <td className="py-2 pr-3">
                <Skeleton className="h-6 w-20 rounded-full" />
              </td>
              <td className="py-2 pr-3">
                <Skeleton className="h-4 w-32" />
              </td>
              <td className="py-2 text-right">
                <div className="flex justify-end gap-0.5">
                  <Skeleton className="size-8 rounded-md" />
                  <Skeleton className="size-8 rounded-md" />
                  <Skeleton className="size-8 rounded-md" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WebhooksLoadingTable;
